export default __webpack_public_path__ + "invitation_error_expired.2016ace.svg";